import script from "./accounts-index.vue?vue&type=script&setup=true&lang=js"
export * from "./accounts-index.vue?vue&type=script&setup=true&lang=js"

import "./accounts-index.vue?vue&type=style&index=0&id=b8723dca&lang=css"

const __exports__ = script;

export default __exports__